import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

export interface IPlatformService {
  isBrowser: boolean;
  isServer: boolean;
}

@Injectable()
export class PlatformService implements IPlatformService {
  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  public get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  public get isServer(): boolean {
    // Code must be update with new check on isSeroRulesSubject for SEO purposes
    // but we keep this as SSR and Scrapper Clientside have the same behaviour atm
    return isPlatformServer(this.platformId) || this.isVCScrapper;
  }

  public get isVCScrapper(): boolean {
    return window?.navigator?.userAgent.toLocaleLowerCase().search(/vestiairebot/i) !== -1;
  }
}
